import getList from './getList';
import add from './add';
import edit from './edit';
import del from './del';
import getContractList from './getContractList';
import getAddr from './getAddr';
export default {
  getList,
  add,
  del,
  edit,
  getContractList,
  getAddr,
};


// WEBPACK FOOTER //
// ./src/api/linemanager/index.ts